<app-navbar-style-three></app-navbar-style-three>

<section class="administration-section">
  <div class="container">
    <!-- Header -->
    <div class="section-header">
      <h1 class="section-header__title">Teacher Information</h1>
      <p class="section-header__subtitle">Faculty Members of School & College Sections</p>
    </div>

    <!-- Navigation Tabs -->
    <div class="teacher-tabs-wrapper">
      <!-- Main Category Level Tabs -->
      <div class="main-tab-nav">
        <button 
          type="button" 
          class="main-tab-btn" 
          [class.main-tab-btn--active]="selectedCategory === 'school'"
          (click)="selectCategory('school')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
          </svg>
          <span>School</span>
        </button>

        <button 
          type="button" 
          class="main-tab-btn" 
          [class.main-tab-btn--active]="selectedCategory === 'college'"
          (click)="selectCategory('college')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
            <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
          </svg>
          <span>College</span>
        </button>

        <button 
          type="button" 
          class="main-tab-btn" 
          [class.main-tab-btn--active]="selectedCategory === 'all'"
          (click)="selectCategory('all')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <span>All Faculty</span>
        </button>
      </div>

      <!-- Sub-Category Tabs for School -->
      <div class="sub-tab-nav" *ngIf="selectedCategory === 'school'">
        <button 
          type="button" 
          class="sub-tab-btn" 
          [class.sub-tab-btn--active]="selectedSubCategory === 'all'"
          (click)="selectSubCategory('all')">
          All School
        </button>
        <button 
          type="button" 
          class="sub-tab-btn" 
          [class.sub-tab-btn--active]="selectedSubCategory === 'bangla-version'"
          (click)="selectSubCategory('bangla-version')">
          1. Bangla Version
        </button>
        <button 
          type="button" 
          class="sub-tab-btn" 
          [class.sub-tab-btn--active]="selectedSubCategory === 'english-version'"
          (click)="selectSubCategory('english-version')">
          2. English Version
        </button>
      </div>

      <!-- Sub-Category Tabs for College -->
      <div class="sub-tab-nav" *ngIf="selectedCategory === 'college'">
        <button 
          type="button" 
          class="sub-tab-btn" 
          [class.sub-tab-btn--active]="selectedSubCategory === 'all'"
          (click)="selectSubCategory('all')">
          All College
        </button>
        <button 
          type="button" 
          class="sub-tab-btn" 
          [class.sub-tab-btn--active]="selectedSubCategory === 'science'"
          (click)="selectSubCategory('science')">
          1. Science
        </button>
        <button 
          type="button" 
          class="sub-tab-btn" 
          [class.sub-tab-btn--active]="selectedSubCategory === 'business-studies'"
          (click)="selectSubCategory('business-studies')">
          2. Business Studies
        </button>
        <button 
          type="button" 
          class="sub-tab-btn" 
          [class.sub-tab-btn--active]="selectedSubCategory === 'humanities'"
          (click)="selectSubCategory('humanities')">
          3. Humanities
        </button>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="administration-content" *ngIf="!fetchinData">
      <!-- Empty State -->
      <div class="empty-state" *ngIf="TeacherInfo == null || TeacherInfo.length === 0">
        <svg class="empty-state__icon" width="80" height="80" viewBox="0 0 24 24" fill="none">
          <path
            d="M22 10V6C22 5.46957 21.7893 4.96086 21.4142 4.58579C21.0391 4.21071 20.5304 4 20 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V10"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M2 10H22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 14V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p class="empty-state__text">No teacher records found in this section</p>
      </div>

      <!-- Teachers Grid (100% matched card design) -->
      <div class="team-grid" *ngIf="TeacherInfo != null && TeacherInfo.length > 0">
        <article class="team-card" *ngFor="let item of TeacherInfo; let i = index" [attr.data-index]="i">
          <div class="team-card__image-wrapper">
            <img [src]="item.ImageLink" [alt]="item.EmployeeName" class="team-card__image" loading="lazy" />
          </div>
          <div class="team-card__content">
            <h3 class="team-card__name">{{ item.EmployeeName }}</h3>
            <p class="team-card__position" *ngIf="item.Subject || item.Department || item.Designation">{{ item.Subject || item.Department || item.Designation }}</p>
            <div class="team-card__badge-wrapper" *ngIf="item.Designation || item.JobArena">
              <span class="team-card__badge-pill">{{ item.Designation || item.JobArena }}</span>
            </div>
          </div>
        </article>
      </div>
    </div>

    <!-- Loading Skeleton -->
    <div class="loading-state" *ngIf="fetchinData">
      <div class="team-grid">
        <div class="team-card" *ngFor="let i of [1,2,3,4,5,6,7,8]" style="border-color: #d1fae5;">
          <div class="skeleton" style="width: 140px; height: 145px; border-radius: 8px; margin: 0 auto 18px;"></div>
          <div class="skeleton" style="width: 75%; height: 20px; border-radius: 4px; margin-bottom: 8px;"></div>
          <div class="skeleton" style="width: 50%; height: 16px; border-radius: 4px; margin-bottom: 16px;"></div>
          <div class="skeleton" style="width: 110px; height: 26px; border-radius: 50px; margin-top: auto;"></div>
        </div>
      </div>
    </div>
  </div>
</section>

